import { ShareAdapter } from "./ShareAdapter";
export class FacebookBasicShareAdapter extends ShareAdapter {
    doShare(data) {
        if (this._data.url.indexOf('localhost') > -1) {
            logger.error('cant share localhost');
        }
        const href = 'https://www.facebook.com/sharer/sharer.php?u=' + data.url + '&picture=' + encodeURIComponent(this._data.image) + '&title=' + encodeURIComponent(data.title) + '&caption=' + encodeURIComponent('') + '&description=' + encodeURIComponent(data.desc) + '&quote=' + encodeURIComponent('');
        window.open(href, 'feedDialog', 'toolbar=0,status=0,width=626,height=436');
    }
}
